export const UPDATE_FILTER_FORM_DATA = "UPDATE_FILTER_FORM_DATA";
export const updateFilterFormData = formData => ({
  type: UPDATE_FILTER_FORM_DATA,
  formData
});

export const CLEAR_FILTER_FORM_DATA = "CLEAR_FILTER_FORM_DATA";
export const clearFilterFormData = () => ({ type: CLEAR_FILTER_FORM_DATA });
